import '@sparta.global.vendors/jquery';

/** Spinner JCR */
let spinnerCopy = null;

/**
 * Initializes the animation utility given the spinner copy.
 * @param {Object} copy Spinner copy
 * @returns {void}
 */
function init(copy) {
  spinnerCopy = copy;
}

/**
 * Starts the page level spinner
 * @param {Object} options Spinner options
 * @returns {void}
 */
function start({
  body,
  heading
}) {
  document.getElementById('spinnerOverlayContainer').removeAttribute('hidden');
  document.body.classList.add('spinner-overlayed');
  document.querySelector('#spinnerOverlayContainer .spa-spin-msg-wrapper').innerHTML = `
    <p class="cnx-regular headline-small">${heading}</p>
    <p>${body}</p>
  `;
}

/**
 * Stops the page level spinner
 * @returns {void}
 */
function stop() {
  const container = document.getElementById('spinnerOverlayContainer');
  container.setAttribute('hidden', 'true');
  document.body.classList.remove('spinner-overlayed');
  container.querySelector('.spa-spin-msg-wrapper').innerText = spinnerCopy.loadingMessage;
}
var waitScreen = {
  start,
  stop,
  init
};

// to convert angle values
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = (angleInDegrees - 90) * (Math.PI / 180.0);
  const x = centerX + radius * Math.cos(angleInRadians);
  const y = centerY + radius * Math.sin(angleInRadians);
  return {
    x,
    y
  };
}

// creates the arc path
function describeArc(x, y, radius, startAngle, arcEndAngle) {
  let endAngle = arcEndAngle;
  if (endAngle === 360) {
    endAngle = 359.999;
  }
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  const movePath = `M ${start.x} ${start.y}`;
  const arcPath = `A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
  const d = `${movePath} ${arcPath}`;
  return d;
}

// update the spinner path attributes
function updateSpinnerPathAttributes(ele, startAngle, endAngle, color, dimension) {
  const path = describeArc(dimension.x, dimension.y, dimension.radius, startAngle, endAngle);
  ele.setAttribute('d', path);
  ele.setAttribute('stroke', color);
}

// start the spinner animation
function animateSpinner(spinnerWrapper, attrs, dimension) {
  const animatingPath = spinnerWrapper.querySelector('#animatingPath');
  const {
    fillColor,
    speed
  } = attrs;
  let angle = 0;
  let fillToggle = true;

  // keep animating spinner recursively
  const recursiveAnimation = () => {
    angle += speed;
    if (angle === 360) {
      fillToggle = !fillToggle;
      angle = 0;
    }
    if (fillToggle) {
      updateSpinnerPathAttributes(animatingPath, 0, angle, fillColor, dimension);
    } else {
      updateSpinnerPathAttributes(animatingPath, angle, 360, fillColor, dimension);
    }
    window.requestAnimationFrame(recursiveAnimation);
  };
  recursiveAnimation();
}

// dynamically creates spinner wrapper div below a button and toggles it off/on
// args: offOn - 'on' or 'off'
//       typ - button class matcher which for now is 'continue' or 'back'
function toggleSaveContinueSpinner$1(offOn, typ = '') {
  // if off then remove class and hide spinner-wrapper
  if (offOn === 'off') {
    waitScreen.stop();
  }

  // if on then add class and show it
  if (offOn === 'on') {
    document.getElementById('spinnerOverlayContainer').removeAttribute('hidden');
    document.body.classList.add('spinner-overlayed');
  }
}
function toggleSpinnerOnButton$1(offOn, btn) {
  toggleSaveContinueSpinner$1(offOn, null);
}
function drawSpinner$1(spinnerWrapperSpan, params) {
  // svg namespace
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const XLINK_NS = 'http://www.w3.org/1999/xlink';

  // SPEED: Must be a factor of 360 ex, can be 1, 2, 5 & 10
  // dimensions of the spinner
  const attrs = {
    width: 97,
    height: 97,
    imageWidth: 70,
    imageHeight: 37,
    strokeWidth: 2,
    speed: 10,
    color: '#ffffff',
    fillColor: '#DC1431',
    ...params
  };
  const x = attrs.height / 2;
  const y = attrs.width / 2;
  const radius = y - attrs.strokeWidth - 1;
  const dimension = {
    x,
    y,
    radius
  };
  const imageX = x - attrs.imageWidth / 2 + 1;
  const imageY = y - attrs.imageHeight / 2 + 1;

  // create the spinner svg
  const viewBox = `0 0 ${attrs.width} ${attrs.height}`;
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('width', attrs.width);
  svg.setAttribute('height', attrs.height);
  svg.setAttribute('viewBox', viewBox);

  // create the paths
  const bgPath = document.createElementNS(SVG_NS, 'path');
  bgPath.setAttribute('id', 'bgPath');
  bgPath.setAttribute('d', describeArc(dimension.x, dimension.y, dimension.radius, 0, 360));
  bgPath.setAttribute('stroke', 'white');
  bgPath.setAttribute('fill', 'none');
  bgPath.setAttribute('stroke-width', attrs.strokeWidth);
  bgPath.setAttribute('opacity', '0.37');
  bgPath.setAttribute('stroke', attrs.color);
  const animatingPath = document.createElementNS(SVG_NS, 'path');
  animatingPath.setAttribute('id', 'animatingPath');
  animatingPath.setAttribute('d', '');
  animatingPath.setAttribute('fill', 'none');
  animatingPath.setAttribute('stroke-width', attrs.strokeWidth);

  // create the svg structure & append it to the span
  svg.appendChild(bgPath);
  svg.appendChild(animatingPath);
  if (attrs.innerCircle) {
    const innerPath = document.createElementNS(SVG_NS, 'path');
    innerPath.setAttribute('id', 'innerPath');
    innerPath.setAttribute('fill', 'white');
    innerPath.setAttribute('opacity', '0.37');
    innerPath.setAttribute('stroke-width', attrs.strokeWidth);
    innerPath.setAttribute('d', describeArc(x, y, attrs.innerCircleRadius, 0, 360));
    innerPath.setAttribute('stroke', 'white');
    svg.appendChild(innerPath);
  }
  if (attrs.imageHref) {
    const centerImage = document.createElementNS(SVG_NS, 'image');
    centerImage.setAttribute('id', 'centerImage');
    centerImage.setAttributeNS(XLINK_NS, 'href', attrs.imageHref);
    centerImage.setAttribute('x', imageX);
    centerImage.setAttribute('y', imageY);
    centerImage.setAttribute('width', attrs.imageWidth);
    centerImage.setAttribute('height', attrs.imageHeight);
    svg.appendChild(centerImage);
  }
  spinnerWrapperSpan.appendChild(svg);

  // start the spinner animation
  animateSpinner(spinnerWrapperSpan, attrs, dimension);
}
var spinner = {
  drawSpinner: drawSpinner$1,
  toggleSaveContinueSpinner: toggleSaveContinueSpinner$1,
  toggleSpinnerOnButton: toggleSpinnerOnButton$1
};

const waitScreenStart = waitScreen.start;
const waitScreenStop = waitScreen.stop;
const {
  drawSpinner,
  toggleSaveContinueSpinner,
  toggleSpinnerOnButton
} = spinner;
var index = {
  waitScreenStart,
  waitScreenStop,
  init: waitScreen.init,
  drawSpinner,
  toggleSaveContinueSpinner,
  toggleSpinnerOnButton
};

export { index as default };
